import "./DigitalAssetsPage.scss";
import "../AppHeader.scss";
import Logo from "../Logo";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { DigitalAssetsLogos } from "./DigitalAssetsLogos";
import { DigitalAssetsColors } from "./DigitalAssetsColors";
import { DigitalAssetsImagery } from "./DigitalAssetsImagery";
import { DigitalAssetsIconography } from "./DigitalAssetsIconography";
import SideNavIcon from "../icons/SideNavIcon";
import { Drawer, Button } from "antd";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
export interface DigitalAssetsPageProps {
  path: string;
}

export default function DigitalAssetsPage({path}: DigitalAssetsPageProps) {
  const [view, setView] = useState(path);
  const [active, setActive] = useState('one');
  const [isDrawerMenu, setDrawerMenu] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', function() {
      let sections = document.querySelectorAll('.scroll-area section');
      sections.forEach((section) => {
        if ((section as HTMLElement).offsetTop <= window.scrollY + 271) {
          setActive(section.classList[0]);
        }
      })
    })
  })

  function changeView(newView: string) {
    setView(newView);
    window.scrollTo({top: 0, behavior: "smooth"});
  }

  function scrollToSection(classname: string) {
    let obj = document.getElementsByClassName(classname)[0] as HTMLElement;
    if (obj) {
      window.scrollTo({top: obj.offsetTop - 241, behavior: "smooth"});
    }
  }

  function downloadZip(name: string) {
    let win = window.open('_blank');
    win!.location.href = `https://timber.mhmcdn.com/site/digitalassets/${name}.zip`;
  }

  const navList = <ul>
    <li>
      <NavLink className={`ant-btn ant-btn-link ant-btn-lg ${window.location.pathname === '/content/assets/' || window.location.pathname === '/content/assets' ? 'active' : ''}`} to={"/content/assets/logos"} onClick={() => changeView('logos')}>Logos</NavLink>
    </li>
    <li>
      <NavLink className={"ant-btn ant-btn-link ant-btn-lg"} to={"/content/assets/colors"} onClick={() => changeView('colors')}>Colors</NavLink>
    </li>
    <li>
      <NavLink className={"ant-btn ant-btn-link ant-btn-lg"} to={"/content/assets/imagery"} onClick={() => changeView('imagery')}>Imagery</NavLink>
    </li>
    <li>
      <NavLink className={"ant-btn ant-btn-link ant-btn-lg"} to={"/content/assets/iconography"} onClick={() => changeView('iconography')}>Iconography</NavLink>
    </li>
  </ul>

  return <div className={"digital-assets-content"}>
    <header className={"main digital-assets-header"}>
      <div className={"nav-container"}>
        <Logo />
        <div className={"mobile-only view-label"}>{view}</div>
        <div className={"desktop-only view-label"}>Brand Elements</div>
        <nav className={"desktop-only"}>
          {navList}
        </nav>
        <div className={"mobile-only mobile-nav-button"} onClick={() => setDrawerMenu(true)}>
          <SideNavIcon/>
        </div>
        <Drawer
          className={"assets-mobile-nav"}
          placement="right"
          width={'100vw'}
          onClose={() => setDrawerMenu(false)}
          visible={isDrawerMenu}
        >
          <div onClick={() => setDrawerMenu(false)}>
            {navList}
          </div>
        </Drawer>
      </div>
      <div className={"assets-banner desktop-only"}>
        <div>
          <p>Brand Elements</p>
          <div className={"border-el"}/>
          <h1>{view}</h1>
        </div>
      </div>
    </header>
    <div className={"sidebar"}>
      {view === 'logos' &&
      <div>
        <ul>
          <li className={active === 'one' ? 'active' : ''} onClick={() => scrollToSection('one')}>
            Logo Variations
          </li>
          <li className={active === 'two' ? 'active' : ''} onClick={() => scrollToSection('two')}>
            Using our logos
          </li>
          <li className={active === 'three' ? 'active' : ''} onClick={() => scrollToSection('three')}>
            Do's & Don'ts
          </li>
        </ul>
        <Button size={"large"} className={"download-btn"} onClick={() => downloadZip('Logos')}><VerticalAlignBottomOutlined/>Download Logos</Button>
      </div>}
      {view === 'colors' &&
      <div>
        <ul>
          <li className={active === 'one' ? 'active' : ''} onClick={() => scrollToSection('one')}>
            Main Brand Colors
          </li>
          <li className={active === 'two' ? 'active' : ''} onClick={() => scrollToSection('two')}>
            Pro Plan
          </li>
          <li className={active === 'three' ? 'active' : ''} onClick={() => scrollToSection('three')}>
            Teams & Locations
          </li>
          <li className={active === 'four' ? 'active' : ''} onClick={() => scrollToSection('four')}>
            Pastels
          </li>
        </ul>
      </div>
      }
      {view === 'imagery' &&
      <div>
        <ul>
          <li className={active === 'one' ? 'active' : ''} onClick={() => scrollToSection('one')}>
            Products on Photo BG
          </li>
          <li className={active === 'two' ? 'active' : ''} onClick={() => scrollToSection('two')}>
            People with Products
          </li>
          <li className={active === 'three' ? 'active' : ''} onClick={() => scrollToSection('three')}>
            Products on Pastel BG
          </li>
          <li className={active === 'four' ? 'active' : ''} onClick={() => scrollToSection('four')}>
            Products on White BG
          </li>
        </ul>
        <Button size={"large"} className={"download-btn"} onClick={() => downloadZip('Images')}><VerticalAlignBottomOutlined/>Download Images</Button>
      </div>
      }
      {view === 'iconography' &&
      <div>
        <ul>
          <li className={active === 'one' ? 'active' : ''} onClick={() => scrollToSection('one')}>
            Custom Icons
          </li>
          <li className={active === 'two' ? 'active' : ''} onClick={() => scrollToSection('two')}>
            Utility Icons
          </li>
        </ul>
        <Button size={"large"} className={"download-btn"} onClick={() => downloadZip('Icons')}><VerticalAlignBottomOutlined/>Download Icons</Button>
      </div>
      }
    </div>
    {view === 'logos' && <DigitalAssetsLogos downloadZip={downloadZip} />}
    {view === 'colors' && <DigitalAssetsColors/>}
    {view === 'imagery' && <DigitalAssetsImagery downloadZip={downloadZip}/>}
    {view === 'iconography' && <DigitalAssetsIconography downloadZip={downloadZip}/>}
  </div>
}
